import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPUpSellFlyOutUI from './PDPUpSellFlyOutUI';
const PDPUpSellFlyOut = t0 => {
  const $ = _c(13);
  const {
    top,
    name,
    price,
    hidePrice,
    salePrice,
    optionPrice,
    promotion,
    imageUrl,
    description,
    closeFlyOut,
    totalReviews,
    averageRating
  } = t0;
  let t1;
  if ($[0] !== averageRating || $[1] !== closeFlyOut || $[2] !== description || $[3] !== hidePrice || $[4] !== imageUrl || $[5] !== name || $[6] !== optionPrice || $[7] !== price || $[8] !== promotion || $[9] !== salePrice || $[10] !== top || $[11] !== totalReviews) {
    t1 = <PDPUpSellFlyOutUI top={top} name={name} price={price} imageUrl={imageUrl} hidePrice={hidePrice} salePrice={salePrice} optionPrice={optionPrice} promotion={promotion} closeFlyOut={closeFlyOut} description={description} totalReviews={totalReviews} averageRating={averageRating} />;
    $[0] = averageRating;
    $[1] = closeFlyOut;
    $[2] = description;
    $[3] = hidePrice;
    $[4] = imageUrl;
    $[5] = name;
    $[6] = optionPrice;
    $[7] = price;
    $[8] = promotion;
    $[9] = salePrice;
    $[10] = top;
    $[11] = totalReviews;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
};
PDPUpSellFlyOut.propTypes = {
  top: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.object,
  optionPrice: PropTypes.number,
  salePrice: PropTypes.number,
  hidePrice: PropTypes.bool,
  imageUrl: PropTypes.string,
  description: PropTypes.string,
  totalReviews: PropTypes.number,
  averageRating: PropTypes.number,
  promotion: PropTypes.shape({
    tiers: PropTypes.arrayOf(PropTypes.shape({
      min_cart: PropTypes.number,
      discount: PropTypes.number
    }))
  }),
  closeFlyOut: PropTypes.func
};
export default PDPUpSellFlyOut;